export default "__VITE_ASSET__BfAxC7Jq__"